module.exports = __webpack_public_path__ + "static/media/breadcrumbs_arrow.cce299fa.svg";